<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form
            action=""
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
        >
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Pregunta</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="description"
                        class="form-control"
                        placeholder="Formule la pregunta"
                    />
                    <span
                        v-if="allerrors.description"
                        :class="['show-error']"
                        >{{ allerrors.description[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Criterio de evaluación</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="contest_question_criteria"
                        placeholder="Seleccione criterio"
                        label="name"
                        track-by="id"
                        :options="arrayCriterias"
                    ></multiselect>
                    <span
                        v-if="allerrors.contest_question_criteria_id"
                        :class="['show-error']"
                        >{{ allerrors.contest_question_criteria_id[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Fase de evaluación</label
                >
                <div class="col-md-9">
                    <!-- <multiselect
                        v-if="
                            evaluation_phase && phase['id'] < evaluation_phase
                        "
                        v-model="phase"
                        placeholder="Seleccione fase"
                        label="description"
                        track-by="id"
                        disabled
                        :options="arrayPhases"
                    ></multiselect> -->
                    <multiselect
                        v-model="phase"
                        placeholder="Seleccione fase"
                        label="description"
                        track-by="id"
                        :options="arrayPhases"
                    ></multiselect>
                    <span v-if="allerrors.phase_id" :class="['show-error']">{{
                        allerrors.phase_id[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="number-input"
                    >Porcentaje</label
                >
                <div class="col-md-9">
                    <input
                        v-if="
                            evaluation_phase && phase['id'] < evaluation_phase
                        "
                        type="number"
                        v-model="percentage"
                        class="form-control"
                        disabled
                        placeholder="ejemmplo 35"
                    />
                    <input
                        v-else
                        type="number"
                        v-model="percentage"
                        class="form-control"
                        placeholder="ejemmplo 35"
                    />
                    <span v-if="allerrors.percentage" :class="['show-error']">{{
                        allerrors.percentage[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Crear
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            description: null,
            percentage: null,
            phase: null,
            arrayCriterias: [],
            arrayPhases: [],
            contest_question_criteria: null,
            evaluation_phase: null,
            allerrors: {
                description: null,
                percentage: null,
                contest_question_criteria_id: null,
                phase_id: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/questions/show/" + me.model_id)
                .then(function (response) {
                    me.description = response.data.model.description;
                    me.percentage = response.data.model.percentage;
                    me.contest_question_criteria =
                        response.data.model.contest_question_criteria;
                    me.phase = response.data.model.phase;
                    me.evaluation_phase = response.data.evaluation_phase;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            if (me.validForm()) {
                axios
                    .post(
                        `/api/contests/questions?contest_id=${me.parent_id}&key=${authUserId}`,
                        {
                            description: me.description,
                            contest_question_criteria_id:
                                me.contest_question_criteria["id"],
                            phase_id: me.phase["id"],
                            percentage: me.percentage,
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.messages
                        ) {
                            me.allerrors = error.response.data.messages;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put("/api/contests/questions/update/" + me.model_id, {
                        description: me.description,
                        contest_question_criteria_id:
                            me.contest_question_criteria["id"],
                        phase_id: me.phase["id"],
                        percentage: me.percentage,
                        contest_id: me.parent_id,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                        me.description = response.data.model.description;
                        me.percentage = response.data.model.percentage;
                        me.type = response.data.model.type;
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        getListQuestionCriteria() {
            let me = this;
            axios
                .get(
                    "/api/contests/question-criteria?paginate=false&contest_id=" +
                        me.parent_id
                )
                .then(function (response) {
                    me.arrayCriterias = response.data;
                })
                .catch(function (error) {});
        },
        getListphase() {
            let me = this;
            axios
                .get("/api/contests/questions/get-phase-list/" + me.parent_id)
                .then(function (response) {
                    me.arrayPhases = response.data;
                })
                .catch(function (error) {});
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.description) {
                me.allerrors.description = [
                    "El campo descripción es obligatorio.",
                ];
                valid = false;
            } else if (me.description.length > 190) {
                me.allerrors.description = [
                    "El campo descripción debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.description = [""];
            }

            if (!me.percentage) {
                me.allerrors.percentage = [
                    "El campo porcentaje es obligatorio.",
                ];
                valid = false;
            } else if (me.percentage.length > 10) {
                me.allerrors.percentage = [
                    "El campo porcentaje debe tener máximo 10 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.percentage = [""];
            }

            if (!me.contest_question_criteria) {
                me.allerrors.contest_question_criteria_id = [
                    "El campo Criterio de evaluación es obligatorio.",
                ];
                valid = false;
            } else {
                me.allerrors.contest_question_criteria_id = [""];
            }

            if (!me.phase) {
                me.allerrors.phase_id = [
                    "El campo fase de evaluación es obligatorio.",
                ];
                valid = false;
            } else {
                me.allerrors.phase_id = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                description: null,
                percentage: null,
                contest_question_criteria_id: null,
                phase_id: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        this.getListQuestionCriteria();
        this.getListphase();
        if (this.model_id > 0) {
            this.getModel();
        }
        return this.model_id;
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
